<template>
  <div :class="style.questionContent">
    <DropdownQuestionContent
      v-if="questionType === 'select'"
      :question="question"
    />

    <OpenListQuestionContent
      v-if="isOpenListQuestion"
      :question="question"
      :question-index="questionIndex"
    />

    <TextQuestionContent v-if="isTextQuestion" :question="question" />

    <InformationQuestionContent
      v-if="questionType === 'information'"
      :question="question"
    />

    <DentalQuestionContent
      v-if="questionType === 'checkbox-dental'"
      :question="question"
    />
  </div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";

import style from "../QuestionPanelComponent.module.scss";
import DropdownQuestionContent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/QuestionSetting/blocks/DropdownQuestion/DropdownQuestionContent.vue";
import {questions, QuestionTypes} from "@/page/quiz/typeQuiz";
import OpenListQuestionContent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/QuestionSetting/blocks/OpenListQuestion/OpenListQuestionContent.vue";
import TextQuestionContent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/QuestionSetting/blocks/TextQuestion/TextQuestionContent.vue";
import InformationQuestionContent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/QuestionSetting/blocks/InformationQuestion/InformationQuestionContent.vue";
import DentalQuestionContent from "@/page/quiz/editor/landingPage/components/elements/SettingPanelComponent/blocks/QuestionSetting/blocks/DentalQuestion/DentalQuestionContent.vue";

export default defineComponent({
  name: "QuestionContentPart",

  components: {
    DentalQuestionContent,
    InformationQuestionContent,
    TextQuestionContent,
    OpenListQuestionContent,
    DropdownQuestionContent
  },

  props: {
    question: {
      type: Object as PropType<questions | null>,
      default: null
    },

    questionIndex: {
      type: Number,
      default: -1
    }
  },

  data() {
    return {
      style
    };
  },

  computed: {
    questionType(): QuestionTypes {
      return this.question?.type || "";
    },
    isOpenListQuestion() {
      const questionTypes = [
        "radio",
        "radio-img",
        "checkbox",
        "checkbox-img"
      ] as QuestionTypes[];
      return questionTypes.includes(this.questionType);
    },
    isTextQuestion() {
      const questionTypes = ["text", "textArea"] as QuestionTypes[];
      return questionTypes.includes(this.questionType);
    }
  },

  methods: {}
});
</script>
